// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import styled from 'styled-components';
import ArrowCard from './ArrowCard';

export default styled(({ left, children, ...props }: React.ComponentProps<any>) => {
  return (
    <ArrowCard
      onClick={(e: Event) => e.stopPropagation()}
      direction="topRight"
      {...props}
    >{children}</ArrowCard>
  )
})`
  position: absolute;
  top: 100%;
  z-index: 1;
`
